const MATCH_ROUTE_REGEX = {
  CURRENT_NEWSLETTER: /^\/newsletter$/i,
  NEWSLETTER: /(?:newsletter|newsletters|articles)/i,
  MY_FAVORITES: /\/favorites/i,
  ETR_INSIGHTS: /\/etr-insights(?:$|\/)/i,
  ETS: /\/ets/i,
  TSIS: /\/research\/((?!drill-downs))((?!Research-Coverage))/i,
  DRILLDOWNS: /\/drill-downs/i,
  MODELS: /^\/drill-downs$|\/drill-downs.+/i,
  ADMIN: /\/admin-bi/i,
}

const DATA_TYPE = {
  ETS: "etsRoutes",
  TSIS: "tsisRoutes",
  DRILLDOWNS: "drilldownsRoutes",
  ADMIN: "adminRoutes",
}

const PATHNAMES = {
  ETS: "ets",
  TSIS: "research",
  TSIS_ABOUT: "research/tsis",
  ETR_INSIGHTS: "etr-insights",
  ETR_SURVEYS: "ets/survey-highlights/10kview",
  NEWSLETTER: "newsletter",
  MY_FAVORITES: "favorites",
  ADMIN: "admin-bi",
  RESEARCH_COVERAGE: "research-coverage",
  DRILLDOWNS: "drill-downs",
}

export { MATCH_ROUTE_REGEX, DATA_TYPE, PATHNAMES }
